import { forwardRef } from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const variants = {
  primary:
    'bg-primary-700 text-cream hover:bg-primary-800 active:bg-primary-900 shadow-soft hover:shadow-card',
  secondary:
    'bg-white text-primary-800 ring-1 ring-primary-200 hover:bg-primary-50 hover:ring-primary-300',
  ghost:
    'bg-transparent text-ink-700 hover:bg-ink-100/70',
  danger:
    'bg-rose-600 text-white hover:bg-rose-700 active:bg-rose-800 shadow-soft',
  accent:
    'bg-accent-500 text-cream hover:bg-accent-600 active:bg-accent-700 shadow-soft',
  outline:
    'bg-transparent text-ink-700 ring-1 ring-ink-200 hover:bg-white hover:ring-ink-300',
}

const sizes = {
  xs: 'h-8 px-3 text-xs',
  sm: 'h-9 px-3.5 text-sm',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-base',
  xl: 'h-12 px-6 text-base',
  icon: 'h-9 w-9 p-0',
}

export const Button = forwardRef(function Button(
  {
    className,
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled,
    children,
    leftIcon,
    rightIcon,
    type = 'button',
    ...props
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl font-semibold',
        'transition-all duration-200 ease-out',
        'focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-cream',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        leftIcon && <span className="-ml-0.5 shrink-0">{leftIcon}</span>
      )}
      {children}
      {!loading && rightIcon && <span className="-mr-0.5 shrink-0">{rightIcon}</span>}
    </button>
  )
})
